// 类型定义

export enum ELoginRegisterCloseType {
  LOGIN = 'login',
  REGISTER = 'register',
  CLOSE = 'close',
  BACK = 'back',
}
